var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 535.68 104.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #0064ff; } .cls-2 { fill: #fff; } .cls-3 { fill: #5bc5f4; } .cls-4 { fill: #00b7ff; } "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,2.66h39.34c36.43,0,57.56,20.98,57.56,50.42v.29c0,29.43-21.42,51.29-58.14,51.29H0V2.66ZM39.78,79.59c16.9,0,28.12-9.33,28.12-25.79v-.29c0-16.32-11.22-25.79-28.12-25.79h-11.51v51.88h11.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.48,2.66h28.27v38.18h36.28V2.66h28.27v102h-28.27v-38.76h-36.28v38.76h-28.27V2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.81,66.48L213.05,2.66h32.2l20.98,37.16,21.13-37.16h31.62l-38.76,63.39v38.62h-28.42v-38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.36,2.66h26.37l41.97,53.92V2.66h27.98v102h-24.77l-43.57-55.96v55.96h-27.98V2.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.69,70.77c0-23.03,18.74-41.76,41.77-41.76s41.76,18.74,41.76,41.76c0,6.32-1.42,12.32-3.95,17.69,8.97-9.39,14.03-22.12,14.5-36.13C423.68,24.77,399.95.89,370.45.02c-28.88-.85-52.32,23.42-52.32,52.32,0,14.02,5.52,26.74,14.5,36.13-2.53-5.38-3.94-11.37-3.94-17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M404.46,70.77c0-18.75-15.26-34.01-34.01-34.01s-34.01,15.26-34.01,34.01c0,9,3.52,17.19,9.26,23.28-.69-2.33-1.07-4.79-1.07-7.34,0-14.24,11.58-25.82,25.82-25.82s25.82,11.58,25.82,25.82c0,2.55-.38,5.01-1.07,7.34,5.73-6.09,9.26-14.28,9.26-23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.52,86.71c0-9.96-8.1-18.07-18.07-18.07s-18.07,8.11-18.07,18.07c0,9.13,6.81,16.68,15.61,17.88.81.04,1.63.06,2.46.06s1.64-.02,2.46-.06c8.8-1.21,15.61-8.75,15.61-17.88Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.211f99701c38d203e5b23cd0dd2f92e3.svg";
export { ForwardRef as ReactComponent };